export default function Hero() {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="hero" className="relative h-screen w-full flex items-center justify-center">
      <div className="absolute inset-0 w-full h-full">
        <img 
          src="https://static.readdy.ai/image/af0cbc08a3b78af074c92730eb798524/c0ed0093df9f4caf324eced96115abab.jpeg"
          alt="Luxury superyacht with helicopter"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/40"></div>
      </div>

      <div className="relative z-10 text-center px-8 max-w-5xl mx-auto">
        <h1 className="font-serif text-6xl md:text-7xl lg:text-8xl text-white mb-8 tracking-tight">
          SYG Yachts
        </h1>
        <p className="text-lg md:text-xl lg:text-2xl text-white/95 mb-12 max-w-3xl mx-auto leading-relaxed font-light">
          Boutique superyacht brokerage and advisory, delivering discreet expertise across sales, charter, and yacht management.
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-6">
          <button 
            onClick={() => scrollToSection('services')}
            className="px-10 py-4 bg-white text-black text-sm tracking-widest hover:bg-black hover:text-white transition-all duration-300 whitespace-nowrap cursor-pointer"
          >
            VIEW SERVICES
          </button>
          <button 
            onClick={() => scrollToSection('contact')}
            className="px-10 py-4 border-2 border-white text-white text-sm tracking-widest hover:bg-white hover:text-black transition-all duration-300 whitespace-nowrap cursor-pointer"
          >
            CONTACT US
          </button>
        </div>
      </div>
    </section>
  );
}